import { action, runInAction, observable } from 'mobx'
import { InternalRatingRequest } from '../requests/internalAssessmentRequest'

class internalAssessmentStore {
  @observable ratings = []
  @observable ratingAllSize = []
  @observable page = 0
  @observable size = 10
  @observable totalCount = 0
  @observable ratingDetails = null
  @observable evaluationDetails = []
  @observable evaluationDetail = []
  @observable status = null

  @observable queryParams = {
    page: 0,
    size: 10,
    title: null,
    month: null,
    year: null,
    departmentCode: null,
  }

  @action setQueryParams = payload => {
    this.queryParams = payload
  }

  @action clearQueryParams = () => {
    this.queryParams = {
      page: 0,
      size: 10,
      title: null,
      year: null,
      month: null,
      status: null,
      create_at: null,
      departmentCode: null,
    }
  }

  @action clearRatings = () => {
    this.ratings = []
    this.totalCount = 0
  }

  @action clearRatingDetails = () => {
    this.ratingDetails = null
  }

  @observable exportData = []

  // Action để lấy dữ liệu từ API
  @action fetchExportData = async queryParams => {
    try {
      // Gọi API để lấy danh sách mã code
      const response = await InternalRatingRequest.getAllRatings(queryParams)
      const listCode = response.data.content.map(el => el.code)

      // Gọi API chi tiết cho từng code
      const requests = listCode.map(code =>
        InternalRatingRequest.getRatingWithDetails(code)
      )
      const responses = await Promise.all(requests)

      // Lưu dữ liệu vào exportData
      this.exportData = responses.map(el => el.data)
      return this.exportData
    } catch (error) {
      console.error('Lỗi khi lấy dữ liệu xuất:', error)
      throw error
    }
  }

  // Action để xóa dữ liệu khi không cần thiết
  @action clearExportData = () => {
    this.exportData = []
  }

  // Lấy danh sách tất cả ratings với phân trang
  @action fetchAllRatings = () => {
    return new Promise((resolve, reject) => {
      InternalRatingRequest.getAllRatings(this.queryParams)
        .then(response => {
          runInAction(() => {
            this.ratings = response.data.content
            this.totalCount = response.data.totalElements
          })
          resolve(response)
        })
        .catch(error => {
          console.error('Error fetching ratings:', error)
          reject(error)
        })
    })
  }

  @action fetchAllSizeRatings = () => {
    return new Promise((resolve, reject) => {
      InternalRatingRequest.getAllRatings({
        size: 200,
      })
        .then(response => {
          runInAction(() => {
            this.ratingAllSize = response.data.content
          })
          resolve(response)
        })
        .catch(error => {
          console.error('Error fetching ratings:', error)
          reject(error)
        })
    })
  }

  // Lấy chi tiết của một rating cụ thể
  @action fetchRatingDetails = code => {
    return new Promise((resolve, reject) => {
      InternalRatingRequest.getRatingWithDetails(code)
        .then(response => {
          runInAction(() => {
            this.ratingDetails = response.data
          })
          resolve(response)
        })
        .catch(error => {
          console.error('Error fetching rating details:', error)
          reject(error)
        })
    })
  }

  // Lấy danh sách evaluation details
  @action fetchEvaluationDetails = code => {
    return new Promise((resolve, reject) => {
      InternalRatingRequest.getEvaluationDetails(code)
        .then(response => {
          runInAction(() => {
            this.evaluationDetails = response.data
          })
          resolve(response)
        })
        .catch(error => {
          console.error('Error fetching evaluation details:', error)
          reject(error)
        })
    })
  }

  // Tạo một phiếu đánh giá mới
  @action createRating = rating => {
    return new Promise((resolve, reject) => {
      InternalRatingRequest.createRating(rating)
        .then(response => {
          runInAction(() => {
            this.ratings.push(response.data)
          })
          resolve(response.data)
        })
        .catch(error => {
          console.error('Error creating rating:', error)
          reject(error)
        })
    })
  }

  @action updateRating = (code, rating) => {
    return new Promise((resolve, reject) => {
      InternalRatingRequest.updateRating(code, rating)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.error('Error updating rating:', error)
          reject(error)
        })
    })
  }

  @action deleteRating = code => {
    return new Promise((resolve, reject) => {
      InternalRatingRequest.deleteRating(code)
        .then(() => {
          runInAction(() => {
            this.ratings = this.ratings.filter(r => r.code !== code)
          })
          resolve()
        })
        .catch(error => {
          console.error('Error deleting rating:', error)
          reject(error)
        })
    })
  }

  @action updateStatus = (code, data) => {
    return new Promise((resolve, reject) => {
      InternalRatingRequest.updateStatus(code, data)
        .then(() => {
          resolve()
        })
        .catch(error => {
          console.error('Error updating status:', error)
          reject(error)
        })
    })
  }

  // Cập nhật chi tiết evaluation detail
  @action updateEvaluationDetail = (code, evaluatorType, detail) => {
    return new Promise((resolve, reject) => {
      InternalRatingRequest.updateEvaluationDetail(code, evaluatorType, detail)
        .then(response => {
          runInAction(() => {
            this.evaluationDetail = response.data
          })
          resolve(response.data)
        })
        .catch(error => {
          console.error('Error updating evaluation detail:', error)
          reject(error)
        })
    })
  }

  @action updateAssignUser = (code, assignUserUpdateRequest) => {
    return new Promise((resolve, reject) => {
      InternalRatingRequest.updateAssignUser(code, assignUserUpdateRequest)
        .then(() => {
          runInAction(() => {
            console.log(`Assigned users updated for rating code: ${code}`)
          })
          resolve()
        })
        .catch(error => {
          console.error('Error updating assigned users:', error)
          reject(error)
        })
    })
  }
}

export default new internalAssessmentStore()
